import React from "react";
import {
  GoogleMap,
  DirectionsService,
  DirectionsRenderer,
} from "@react-google-maps/api";

const containerStyle = { width: "100%", height: "100%" };
const center = { lat: 18.5204, lng: 73.8567 };

const MapView = ({
  origin,
  destination,
  travelMode,
  routeIndex,
  response,
  directionsCallback,
}) => {
  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={13}>
      {response === null && origin && destination && (
        <DirectionsService
          options={{
            origin: origin?.value,
            destination: destination?.value || destination,
            travelMode: travelMode,
            provideRouteAlternatives: true,
          }}
          callback={directionsCallback}
        />
      )}

      {response !== null && (
        <DirectionsRenderer
          options={{
            directions: response,
            routeIndex: routeIndex,
            polylineOptions: {
              strokeColor: "#1938e7",
              strokeOpacity: 0.9,
              strokeWeight: 6,
            },
          }}
        />
      )}
    </GoogleMap>
  );
};

export default MapView;
